import storage from 'redux-persist/lib/storage/session'; // Use sessionStorage

/**
 * Redux Persist Configuration
 * 
 * Uses sessionStorage for authentication persistence
 * - Clears when browser tab is closed (better security)
 * - Persists across page refreshes
 * - Single source of truth: Redux Store
 */
export const persistConfig = {
  key: 'root',
  storage, // sessionStorage
  whitelist: ['Login', 'Layout'], // Persist auth state and layout preferences (theme, sidebar, etc.)
  // Blacklist other reducers that shouldn't persist
  blacklist: ['Otp', 'Leads', 'Clients', 'ClientSites', 'Products', 'Quotes', 'WorkOrders'],
};

